// extracted by mini-css-extract-plugin
module.exports = {"strip":"ProcessStrip_strip__DSAD6","icon":"ProcessStrip_icon__KcPKX","copy":"ProcessStrip_copy__Lvrjl"};